import $ from 'jquery';
import pianoNote1 from '../assets/sounds/piano/pianoNote1.mp3';
import pianoNote10 from '../assets/sounds/piano/pianoNote10.mp3';
import pianoNote11 from '../assets/sounds/piano/pianoNote11.mp3';
import pianoNote12 from '../assets/sounds/piano/pianoNote12.mp3';
import pianoNote2 from '../assets/sounds/piano/pianoNote2.mp3';
import pianoNote3 from '../assets/sounds/piano/pianoNote3.mp3';
import pianoNote4 from '../assets/sounds/piano/pianoNote4.mp3';
import pianoNote5 from '../assets/sounds/piano/pianoNote5.mp3';
import pianoNote6 from '../assets/sounds/piano/pianoNote6.mp3';
import pianoNote7 from '../assets/sounds/piano/pianoNote7.mp3';
import pianoNote8 from '../assets/sounds/piano/pianoNote8.mp3';
import pianoNote9 from '../assets/sounds/piano/pianoNote9.mp3';
import soundRecorder from "../assets/sounds/recorder/soundRecorder.mp3";
import bonus1SA from '../assets/sounds/sekansAcid/bonus1SA.mp3';
import bonus2SA from '../assets/sounds/sekansAcid/bonus2SA.mp3';
import bonus3SA from '../assets/sounds/sekansAcid/bonus3SA.mp3';
import clapSA from '../assets/sounds/sekansAcid/clapSA.mp3';
import cowbellSA from '../assets/sounds/sekansAcid/cowbellSA.mp3';
import hihatSA from '../assets/sounds/sekansAcid/hihatSA.mp3';
import kickSA from '../assets/sounds/sekansAcid/kickSA.mp3';
import openHihatSA from '../assets/sounds/sekansAcid/openHihatSA.mp3';
import snareSA from '../assets/sounds/sekansAcid/snareSA.mp3';
import bonus1SG from '../assets/sounds/sekansGlacier/bonus1SG.mp3';
import bonus2SG from '../assets/sounds/sekansGlacier/bonus2SG.mp3';
import bonus3SG from '../assets/sounds/sekansGlacier/bonus3SG.mp3';
import clapSG from '../assets/sounds/sekansGlacier/clapSG.mp3';
import cowbellSG from '../assets/sounds/sekansGlacier/cowbellSG.mp3';
import hihatSG from '../assets/sounds/sekansGlacier/hihatSG.mp3';
import kickSG from '../assets/sounds/sekansGlacier/kickSG.mp3';
import openHihatSG from '../assets/sounds/sekansGlacier/openHihatSG.mp3';
import snareSG from '../assets/sounds/sekansGlacier/snareSG.mp3';
import bonus1SP from '../assets/sounds/sekansPrototype/bonus1SP.mp3';
import bonus2SP from '../assets/sounds/sekansPrototype/bonus2SP.mp3';
import bonus3SP from '../assets/sounds/sekansPrototype/bonus3SP.mp3';
import clapSP from '../assets/sounds/sekansPrototype/clapSP.mp3';
import cowbellSP from '../assets/sounds/sekansPrototype/cowbellSP.mp3';
import hihatSP from '../assets/sounds/sekansPrototype/hihatSP.mp3';
import kickSP from '../assets/sounds/sekansPrototype/kickSP.mp3';
import openHihatSP from '../assets/sounds/sekansPrototype/openHihatSP.mp3';
import snareSP from '../assets/sounds/sekansPrototype/snareSP.mp3';
import bonus1SR from '../assets/sounds/sekansRoyale/bonus1SR.mp3';
import bonus2SR from '../assets/sounds/sekansRoyale/bonus2SR.mp3';
import bonus3SR from '../assets/sounds/sekansRoyale/bonus3SR.mp3';
import clapSR from '../assets/sounds/sekansRoyale/clapSR.mp3';
import cowbellSR from '../assets/sounds/sekansRoyale/cowbellSR.mp3';
import hihatSR from '../assets/sounds/sekansRoyale/hihatSR.mp3';
import kickSR from '../assets/sounds/sekansRoyale/kickSR.mp3';
import openHihatSR from '../assets/sounds/sekansRoyale/openHihatSR.mp3';
import snareSR from '../assets/sounds/sekansRoyale/snareSR.mp3';
import bonus1SV from '../assets/sounds/sekansVolcano/bonus1SV.mp3';
import bonus2SV from '../assets/sounds/sekansVolcano/bonus2SV.mp3';
import bonus3SV from '../assets/sounds/sekansVolcano/bonus3SV.mp3';
import clapSV from '../assets/sounds/sekansVolcano/clapSV.mp3';
import cowbellSV from '../assets/sounds/sekansVolcano/cowbellSV.mp3';
import hihatSV from '../assets/sounds/sekansVolcano/hihatSV.mp3';
import kickSV from '../assets/sounds/sekansVolcano/kickSV.mp3';
import openHihatSV from '../assets/sounds/sekansVolcano/openHihatSV.mp3';
import snareSV from '../assets/sounds/sekansVolcano/snareSV.mp3';
import seqBassDrum from '../assets/sounds/sequenceur/bassDrum.wav';
import seqClave from '../assets/sounds/sequenceur/clave.wav';
import seqCloseHH from '../assets/sounds/sequenceur/closeHH.wav';
import seqElectroClick from '../assets/sounds/sequenceur/electroClick.wav';
import seqFish from '../assets/sounds/sequenceur/fish.wav';
import seqMedTom from '../assets/sounds/sequenceur/medTom.wav';
import seqMuffledBassDrum from '../assets/sounds/sequenceur/muffledBassDrum.wav';
import seqOpenHH from '../assets/sounds/sequenceur/openHH.wav';
import seqRim from '../assets/sounds/sequenceur/rim.wav';
import seqSemiOpenHH from '../assets/sounds/sequenceur/semiOpenHH.wav';
import seqSmallTom from '../assets/sounds/sequenceur/smallTom.wav';
import seqSnare from '../assets/sounds/sequenceur/snare.wav';
import bass1XA from '../assets/sounds/xopowoAcid/xopowoAcidBass1.mp3';
import bass2XA from '../assets/sounds/xopowoAcid/xopowoAcidBass2.mp3';
import bass3XA from '../assets/sounds/xopowoAcid/xopowoAcidBass3.mp3';
import beatXA from '../assets/sounds/xopowoAcid/xopowoAcidBeat.mp3';
import hihatXA from '../assets/sounds/xopowoAcid/xopowoAcidHihats.mp3';
import kickXA from '../assets/sounds/xopowoAcid/xopowoAcidKick.mp3';
import loopXA from '../assets/sounds/xopowoAcid/xopowoAcidLoop.mp3';
import pad1XA from '../assets/sounds/xopowoAcid/xopowoAcidPad1.mp3';
import pad2XA from '../assets/sounds/xopowoAcid/xopowoAcidPad2.mp3';
import pad3XA from '../assets/sounds/xopowoAcid/xopowoAcidPad3.mp3';
import snareXA from '../assets/sounds/xopowoAcid/xopowoAcidSnare.mp3';
import bass1XG from '../assets/sounds/xopowoGenesis/xopowoGenesisBass1.mp3';
import bass2XG from '../assets/sounds/xopowoGenesis/xopowoGenesisBass2.mp3';
import bass3XG from '../assets/sounds/xopowoGenesis/xopowoGenesisBass3.mp3';
import beatXG from '../assets/sounds/xopowoGenesis/xopowoGenesisBeat.mp3';
import hihatXG from '../assets/sounds/xopowoGenesis/xopowoGenesisHihats.mp3';
import kickXG from '../assets/sounds/xopowoGenesis/xopowoGenesisKick.mp3';
import loopXG from '../assets/sounds/xopowoGenesis/xopowoGenesisLoop.mp3';
import pad1XG from '../assets/sounds/xopowoGenesis/xopowoGenesisPad1.mp3';
import pad2XG from '../assets/sounds/xopowoGenesis/xopowoGenesisPad2.mp3';
import pad3XG from '../assets/sounds/xopowoGenesis/xopowoGenesisPad3.mp3';
import snareXG from '../assets/sounds/xopowoGenesis/xopowoGenesisSnare.mp3';
import bass1XGl from '../assets/sounds/xopowoGlacier/xopowoGlacierBass1.mp3';
import bass2XGl from '../assets/sounds/xopowoGlacier/xopowoGlacierBass2.mp3';
import bass3XGl from '../assets/sounds/xopowoGlacier/xopowoGlacierBass3.mp3';
import beatXGl from '../assets/sounds/xopowoGlacier/xopowoGlacierBeat.mp3';
import hihatXGl from '../assets/sounds/xopowoGlacier/xopowoGlacierHihats.mp3';
import kickXGl from '../assets/sounds/xopowoGlacier/xopowoGlacierKick.mp3';
import loopXGl from '../assets/sounds/xopowoGlacier/xopowoGlacierLoop.mp3';
import pad1XGl from '../assets/sounds/xopowoGlacier/xopowoGlacierPad1.mp3';
import pad2XGl from '../assets/sounds/xopowoGlacier/xopowoGlacierPad2.mp3';
import pad3XGl from '../assets/sounds/xopowoGlacier/xopowoGlacierPad3.mp3';
import snareXGl from '../assets/sounds/xopowoGlacier/xopowoGlacierSnare.mp3';
import bass1XN from '../assets/sounds/xopowoNightmare/xopowoNightmareBass1.mp3';
import bass2XN from '../assets/sounds/xopowoNightmare/xopowoNightmareBass2.mp3';
import bass3XN from '../assets/sounds/xopowoNightmare/xopowoNightmareBass3.mp3';
import beatXN from '../assets/sounds/xopowoNightmare/xopowoNightmareBeat.mp3';
import hihatXN from '../assets/sounds/xopowoNightmare/xopowoNightmareHihats.mp3';
import kickXN from '../assets/sounds/xopowoNightmare/xopowoNightmareKick.mp3';
import loopXN from '../assets/sounds/xopowoNightmare/xopowoNightmareLoop.mp3';
import pad1XN from '../assets/sounds/xopowoNightmare/xopowoNightmarePad1.mp3';
import pad2XN from '../assets/sounds/xopowoNightmare/xopowoNightmarePad2.mp3';
import pad3XN from '../assets/sounds/xopowoNightmare/xopowoNightmarePad3.mp3';
import snareXN from '../assets/sounds/xopowoNightmare/xopowoNightmareSnare.mp3';
import bass1XO from '../assets/sounds/xopowoOnyx/xopowoOnyxBass1.mp3';
import bass2XO from '../assets/sounds/xopowoOnyx/xopowoOnyxBass2.mp3';
import bass3XO from '../assets/sounds/xopowoOnyx/xopowoOnyxBass3.mp3';
import beatXO from '../assets/sounds/xopowoOnyx/xopowoOnyxBeat.mp3';
import hihatXO from '../assets/sounds/xopowoOnyx/xopowoOnyxHihats.mp3';
import kickXO from '../assets/sounds/xopowoOnyx/xopowoOnyxKick.mp3';
import loopXO from '../assets/sounds/xopowoOnyx/xopowoOnyxLoop.mp3';
import pad1XO from '../assets/sounds/xopowoOnyx/xopowoOnyxPad1.mp3';
import pad2XO from '../assets/sounds/xopowoOnyx/xopowoOnyxPad2.mp3';
import pad3XO from '../assets/sounds/xopowoOnyx/xopowoOnyxPad3.mp3';
import snareXO from '../assets/sounds/xopowoOnyx/xopowoOnyxSnare.mp3';
import bass1XP from '../assets/sounds/xopowoPoisoned/xopowoPoisonedBass1.mp3';
import bass2XP from '../assets/sounds/xopowoPoisoned/xopowoPoisonedBass2.mp3';
import bass3XP from '../assets/sounds/xopowoPoisoned/xopowoPoisonedBass3.mp3';
import beatXP from '../assets/sounds/xopowoPoisoned/xopowoPoisonedBeat.mp3';
import hihatXP from '../assets/sounds/xopowoPoisoned/xopowoPoisonedHihats.mp3';
import kickXP from '../assets/sounds/xopowoPoisoned/xopowoPoisonedKick.mp3';
import loopXP from '../assets/sounds/xopowoPoisoned/xopowoPoisonedLoop.mp3';
import pad1XP from '../assets/sounds/xopowoPoisoned/xopowoPoisonedPad1.mp3';
import pad2XP from '../assets/sounds/xopowoPoisoned/xopowoPoisonedPad2.mp3';
import pad3XP from '../assets/sounds/xopowoPoisoned/xopowoPoisonedPad3.mp3';
import snareXP from '../assets/sounds/xopowoPoisoned/xopowoPoisonedSnare.mp3';
import bass1XR from '../assets/sounds/xopowoRoyale/xopowoRoyaleBass1.mp3';
import bass2XR from '../assets/sounds/xopowoRoyale/xopowoRoyaleBass2.mp3';
import bass3XR from '../assets/sounds/xopowoRoyale/xopowoRoyaleBass3.mp3';
import beatXR from '../assets/sounds/xopowoRoyale/xopowoRoyaleBeat.mp3';
import hihatXR from '../assets/sounds/xopowoRoyale/xopowoRoyaleHihats.mp3';
import kickXR from '../assets/sounds/xopowoRoyale/xopowoRoyaleKick.mp3';
import loopXR from '../assets/sounds/xopowoRoyale/xopowoRoyaleLoop.mp3';
import pad1XR from '../assets/sounds/xopowoRoyale/xopowoRoyalePad1.mp3';
import pad2XR from '../assets/sounds/xopowoRoyale/xopowoRoyalePad2.mp3';
import pad3XR from '../assets/sounds/xopowoRoyale/xopowoRoyalePad3.mp3';
import snareXR from '../assets/sounds/xopowoRoyale/xopowoRoyaleSnare.mp3';
import bass1XS from '../assets/sounds/xopowoSunset/xopowoSunsetBass1.mp3';
import bass2XS from '../assets/sounds/xopowoSunset/xopowoSunsetBass2.mp3';
import bass3XS from '../assets/sounds/xopowoSunset/xopowoSunsetBass3.mp3';
import beatXS from '../assets/sounds/xopowoSunset/xopowoSunsetBeat.mp3';
import hihatXS from '../assets/sounds/xopowoSunset/xopowoSunsetHihats.mp3';
import kickXS from '../assets/sounds/xopowoSunset/xopowoSunsetKick.mp3';
import loopXS from '../assets/sounds/xopowoSunset/xopowoSunsetLoop.mp3';
import pad1XS from '../assets/sounds/xopowoSunset/xopowoSunsetPad1.mp3';
import pad2XS from '../assets/sounds/xopowoSunset/xopowoSunsetPad2.mp3';
import pad3XS from '../assets/sounds/xopowoSunset/xopowoSunsetPad3.mp3';
import snareXS from '../assets/sounds/xopowoSunset/xopowoSunsetSnare.mp3';
import bass1XT from '../assets/sounds/xopowoTemple/xopowoTempleBass1.mp3';
import bass2XT from '../assets/sounds/xopowoTemple/xopowoTempleBass2.mp3';
import bass3XT from '../assets/sounds/xopowoTemple/xopowoTempleBass3.mp3';
import beatXT from '../assets/sounds/xopowoTemple/xopowoTempleBeat.mp3';
import hihatXT from '../assets/sounds/xopowoTemple/xopowoTempleHihats.mp3';
import kickXT from '../assets/sounds/xopowoTemple/xopowoTempleKick.mp3';
import loopXT from '../assets/sounds/xopowoTemple/xopowoTempleLoop.mp3';
import pad1XT from '../assets/sounds/xopowoTemple/xopowoTemplePad1.mp3';
import pad2XT from '../assets/sounds/xopowoTemple/xopowoTemplePad2.mp3';
import pad3XT from '../assets/sounds/xopowoTemple/xopowoTemplePad3.mp3';
import snareXT from '../assets/sounds/xopowoTemple/xopowoTempleSnare.mp3';
import bass1XV from '../assets/sounds/xopowoVolcano/xopowoVolcanoBass1.mp3';
import bass2XV from '../assets/sounds/xopowoVolcano/xopowoVolcanoBass2.mp3';
import bass3XV from '../assets/sounds/xopowoVolcano/xopowoVolcanoBass3.mp3';
import beatXV from '../assets/sounds/xopowoVolcano/xopowoVolcanoBeat.mp3';
import hihatXV from '../assets/sounds/xopowoVolcano/xopowoVolcanoHihats.mp3';
import kickXV from '../assets/sounds/xopowoVolcano/xopowoVolcanoKick.mp3';
import loopXV from '../assets/sounds/xopowoVolcano/xopowoVolcanoLoop.mp3';
import pad1XV from '../assets/sounds/xopowoVolcano/xopowoVolcanoPad1.mp3';
import pad2XV from '../assets/sounds/xopowoVolcano/xopowoVolcanoPad2.mp3';
import pad3XV from '../assets/sounds/xopowoVolcano/xopowoVolcanoPad3.mp3';
import snareXV from '../assets/sounds/xopowoVolcano/xopowoVolcanoSnare.mp3';



const SOUND_ON = true

function Sound(src, maxStreams = 1, vol = 1.0) {
  this.streamNum = 0;
  this.streams = [];
  this.maxStreams = maxStreams
  
  let source = 'bass1XG'
  
  switch(src) {
    case "bass1XG":
      source = bass1XG
      break
    
    case "bass2XG":
      source = bass2XG
      break

    case "bass3XG":
      source = bass3XG
      break

    case "kickXG":
      source = kickXG
      break

    case "hihatXG":
      source = hihatXG
      break

    case "snareXG":
      source = snareXG
      break

    case "pad1XG":
      source = pad1XG
      break

    case "pad2XG":
      source = pad2XG
      break

    case "pad3XG":
      source = pad3XG
      break

    case "loopXG":
      source = loopXG
      break

    case "beatXG":
      source = beatXG
      break

    case "bass1XO":
      source = bass1XO
      break
    
    case "bass2XO":
      source = bass2XO
      break

    case "bass3XO":
      source = bass3XO
      break

    case "kickXO":
      source = kickXO
      break

    case "hihatXO":
      source = hihatXO
      break

    case "snareXO":
      source = snareXO
      break

    case "pad1XO":
      source = pad1XO
      break

    case "pad2XO":
      source = pad2XO
      break

    case "pad3XO":
      source = pad3XO
      break

    case "loopXO":
      source = loopXO
      break

    case "beatXO":
      source = beatXO
      break

    case "bass1XGl":
      source = bass1XGl
      break
    
    case "bass2XGl":
      source = bass2XGl
      break

    case "bass3XGl":
      source = bass3XGl
      break

    case "kickXGl":
      source = kickXGl
      break

    case "hihatXGl":
      source = hihatXGl
      break

    case "snareXGl":
      source = snareXGl
      break

    case "pad1XGl":
      source = pad1XGl
      break

    case "pad2XGl":
      source = pad2XGl
      break

    case "pad3XGl":
      source = pad3XGl
      break

    case "loopXGl":
      source = loopXGl
      break

    case "beatXGl":
      source = beatXGl
      break

    case "bass1XN":
      source = bass1XN
      break
    
    case "bass2XN":
      source = bass2XN
      break

    case "bass3XN":
      source = bass3XN
      break

    case "kickXN":
      source = kickXN
      break

    case "hihatXN":
      source = hihatXN
      break

    case "snareXN":
      source = snareXN
      break

    case "pad1XN":
      source = pad1XN
      break

    case "pad2XN":
      source = pad2XN
      break

    case "pad3XN":
      source = pad3XN
      break

    case "loopXN":
      source = loopXN
      break  

    case "beatXN":
      source = beatXN
      break  

    case "bass1XS":
      source = bass1XS
      break
    
    case "bass2XS":
      source = bass2XS
      break

    case "bass3XS":
      source = bass3XS
      break

    case "kickXS":
      source = kickXS
      break

    case "hihatXS":
      source = hihatXS
      break

    case "snareXS":
      source = snareXS
      break

    case "pad1XS":
      source = pad1XS
      break

    case "pad2XS":
      source = pad2XS
      break

    case "pad3XS":
      source = pad3XS
      break

    case "loopXS":
      source = loopXS
      break  

    case "beatXS":
      source = beatXS
      break  

    case "bass1XT":
      source = bass1XT
      break
    
    case "bass2XT":
      source = bass2XT
      break

    case "bass3XT":
      source = bass3XT
      break

    case "kickXT":
      source = kickXT
      break

    case "hihatXT":
      source = hihatXT
      break

    case "snareXT":
      source = snareXT
      break

    case "pad1XT":
      source = pad1XT
      break

    case "pad2XT":
      source = pad2XT
      break

    case "pad3XT":
      source = pad3XT
      break

    case "loopXT":
      source = loopXT
      break  

    case "beatXT":
      source = beatXT
      break  

    case "bass1XA":
      source = bass1XA
      break
    
    case "bass2XA":
      source = bass2XA
      break

    case "bass3XA":
      source = bass3XA
      break

    case "kickXA":
      source = kickXA
      break

    case "hihatXA":
      source = hihatXA
      break

    case "snareXA":
      source = snareXA
      break

    case "pad1XA":
      source = pad1XA
      break

    case "pad2XA":
      source = pad2XA
      break

    case "pad3XA":
      source = pad3XA
      break

    case "loopXA":
      source = loopXA
      break  

    case "beatXA":
      source = beatXA
      break  

    case "bass1XP":
      source = bass1XP
      break
    
    case "bass2XP":
      source = bass2XP
      break

    case "bass3XP":
      source = bass3XP
      break

    case "kickXP":
      source = kickXP
      break

    case "hihatXP":
      source = hihatXP
      break

    case "snareXP":
      source = snareXP
      break

    case "pad1XP":
      source = pad1XP
      break

    case "pad2XP":
      source = pad2XP
      break

    case "pad3XP":
      source = pad3XP
      break

    case "loopXP":
      source = loopXP
      break  

    case "beatXP":
      source = beatXP
      break  

    case "bass1XR":
    source = bass1XR
    break
    
    case "bass2XR":
      source = bass2XR
      break

    case "bass3XR":
      source = bass3XR
      break

    case "kickXR":
      source = kickXR
      break

    case "hihatXR":
      source = hihatXR
      break

    case "snareXR":
      source = snareXR
      break

    case "pad1XR":
      source = pad1XR
      break

    case "pad2XR":
      source = pad2XR
      break

    case "pad3XR":
      source = pad3XR
      break

    case "loopXR":
      source = loopXR
      break  

    case "beatXR":
      source = beatXR
      break 

    case "bass1XV":
      source = bass1XV
      break

    case "bass2XV":
      source = bass2XV
      break

    case "bass3XV":
      source = bass3XV
      break

    case "kickXV":
      source = kickXV
      break

    case "hihatXV":
      source = hihatXV
      break

    case "snareXV":
      source = snareXV
      break

    case "pad1XV":
      source = pad1XV
      break

    case "pad2XV":
      source = pad2XV
      break

    case "pad3XV":
      source = pad3XV
      break

    case "loopXV":
      source = loopXV
      break  

    case "beatXV":
      source = beatXV
      break 

    case "kickSP":
      source = kickSP
      break

    case "snareSP":
      source = snareSP
      break

    case "hihatSP":
      source = hihatSP
      break

    case "openHihatSP":
      source = openHihatSP
      break

    case "clapSP":
      source = clapSP
      break

    case "cowbellSP":
      source = cowbellSP
      break

    case "bonus1SP":
      source = bonus1SP
      break

    case "bonus2SP":
      source = bonus2SP
      break  

    case "bonus3SP":
      source = bonus3SP
      break 

    case "kickSG":
      source = kickSG
      break

    case "snareSG":
      source = snareSG
      break

    case "hihatSG":
      source = hihatSG
      break

    case "openHihatSG":
      source = openHihatSG
      break

    case "clapSG":
      source = clapSG
      break

    case "cowbellSG":
      source = cowbellSG
      break

    case "bonus1SG":
      source = bonus1SG
      break

    case "bonus2SG":
      source = bonus2SG
      break  

    case "bonus3SG":
      source = bonus3SG
      break 

    case "kickSA":
      source = kickSA
      break

    case "snareSA":
      source = snareSA
      break

    case "hihatSA":
      source = hihatSA
      break

    case "openHihatSA":
      source = openHihatSA
      break

    case "clapSA":
      source = clapSA
      break

    case "cowbellSA":
      source = cowbellSA
      break

    case "bonus1SA":
      source = bonus1SA
      break

    case "bonus2SA":
      source = bonus2SA
      break  

    case "bonus3SA":
      source = bonus3SA
      break 

    case "kickSV":
      source = kickSV
      break

    case "snareSV":
      source = snareSV
      break

    case "hihatSV":
      source = hihatSV
      break

    case "openHihatSV":
      source = openHihatSV
      break

    case "clapSV":
      source = clapSV
      break

    case "cowbellSV":
      source = cowbellSV
      break

    case "bonus1SV":
      source = bonus1SV
      break

    case "bonus2SV":
      source = bonus2SV
      break  

    case "bonus3SV":
      source = bonus3SV
      break 

    case "kickSR":
      source = kickSR
      break

    case "snareSR":
      source = snareSR
      break

    case "hihatSR":
      source = hihatSR
      break

    case "openHihatSR":
      source = openHihatSR
      break

    case "clapSR":
      source = clapSR
      break

    case "cowbellSR":
      source = cowbellSR
      break

    case "bonus1SR":
      source = bonus1SR
      break

    case "bonus2SR":
      source = bonus2SR
      break  

    case "bonus3SR":
      source = bonus3SR
      break 

    case "seqBassDrum":
      source = seqBassDrum
      break 
      
    case "seqMuffledBassDrum":
      source = seqMuffledBassDrum
      break 
      
    case "seqCloseHH":
      source = seqCloseHH
      break 
      
    case "seqSemiOpenHH":
      source = seqSemiOpenHH
      break 
      
    case "seqOpenHH":
      source = seqOpenHH
      break 
      
    case "seqSnare":
      source = seqSnare
      break 
      
    case "seqRim":
      source = seqRim
      break 
      
    case "seqSmallTom":
      source = seqSmallTom
      break 
      
    case "seqMedTom":
      source = seqMedTom
      break 
      
    case "seqFish":
      source = seqFish
      break 
      
    case "seqClave":
      source = seqClave
      break 
      
    case "seqElectroClick":
      source = seqElectroClick
      break 

    case "soundRecorder":
      source = soundRecorder
      break

    case "pianoNote1":
      source = pianoNote1
      break

    case "pianoNote2":
      source = pianoNote2
      break

    case "pianoNote3":
      source = pianoNote3
      break

    case "pianoNote4":
      source = pianoNote4
      break

    case "pianoNote5":
      source = pianoNote5
      break

    case "pianoNote6":
      source = pianoNote6
      break

    case "pianoNote7":
      source = pianoNote7
      break

    case "pianoNote8":
      source = pianoNote8
      break

    case "pianoNote9":
      source = pianoNote9
      break

    case "pianoNote10":
      source = pianoNote10
      break

    case "pianoNote11":
      source = pianoNote11
      break

    case "pianoNote12":
      source = pianoNote12
      break

    default: break
  }

  for (let i = 0; i < this.maxStreams; i++) {
    this.streams.push(new Audio(source));
    this.streams[i].volume = vol;
    if (
      source === loopXO 
      || source === loopXG 
      || source === loopXGl 
      || source === loopXN
      || source === loopXS 
      || source === loopXT
      || source === loopXA
      || source === loopXP
      || source === loopXR
      || source === loopXV
      || source === beatXG
      || source === beatXGl
      || source === beatXN
      || source === beatXO
      || source === beatXS
      || source === beatXT
      || source === beatXA
      || source === beatXP
      || source === beatXR
      || source === beatXV
    ) this.streams[i].setAttribute("loop", "true")
  }
  
  this.play = function() {
    if (SOUND_ON) {
      this.streamNum = (this.streamNum + 1) % this.maxStreams;
      const sound = this.streams[this.streamNum]
      //console.log(sound.volume)
      sound.volume = 1.0
      //console.log(sound.volume)
      sound.play();
      //console.log(sound.volume)
    }
  }

  this.stop = function() {
    const sound = this.streams[this.streamNum]
    const soundObj = $(sound)

    if (sound.volume > 0) {
      soundObj.animate({volume: 0}, 25, () => {
        
        sound.pause()
        sound.currentTime = 0
      })
    }
  }

  this.fadeIn = () => {
    if (SOUND_ON) {
      this.streamNum = (this.streamNum + 1) % this.maxStreams;
      const sound = this.streams[this.streamNum]
      
      if (sound.volume < 1.0) {
        sound.volume = parseFloat(sound.volume + 0.1).toFixed(2)
        //console.log(sound.volume)
        setTimeout(this.fadeIn(), 1)
      }
      else {
        //console.log('ici')
        //console.log(sound.volume)
        sound.play()
      }
    }
  }

  this.fadeOut = () => {
    const sound = this.streams[this.streamNum]

    if (sound.volume !== 0) {
      /* let volume = parseFloat(sound.volume - 0.1).toFixed(2)
      if (volume < 0.003) volume = 0.003
      sound.volume = volume */
      sound.volume = 0.003
      if (sound.volume >= 0.1) setTimeout(this.fadeOut(), 1)
    }
    else {
      //console.log('ici')
      //console.log(sound.volume)
      sound.pause()
      sound.currentTime = 0
    }

    
    // let soundInterval = null

    

    // if (sound.volume > 0.1) {
    //   soundInterval = setInterval(() => {
    //     const volume = parseFloat(sound.volume - 0.1).toFixed(2)
    //     if (!volume < 0) sound.volume = volume
    //     console.log(sound.volume)
    //     if (sound.volume === 0) {
    //       sound.pause()
    //       sound.currentTime = 0
    //       clearInterval(soundInterval)
    //     }
    //   }, 2)
    // }
    
    // else {
    //   console.log('ici')
    //   sound.volume = 0.0
          
    //   sound.pause()
    //   sound.currentTime = 0
    //   clearInterval(soundInterval)
    // }

  }

  this.stopAll = () => {
    for (let i = 0; i < this.streams.length; i++) {
      const sound = this.streams[i]
      const soundObj = $(sound)

      if (sound.volume > 0) {
        soundObj.animate({volume: 0}, 5, "linear", () => {
          sound.pause()
          sound.currentTime = 0
        })
      }
    } 
  }
}

export default Sound
